import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		disable: true
		/*
		primary: '#03A4AB',
		secondary: '#161a3c',
		accent: '#ffc95e',
		error: '#AE2727',
		info: '#2196F3',
		success: '#56BB81',
		warning: '#E9A43C',
		anchor: '#03A4AB',
		*/
	}
});
